import { BehaviorSubject } from "rxjs";

const drawerMessageBehaviorSubject = new BehaviorSubject();

const adMessageCounterBehaviorSubject = new BehaviorSubject();
const busMessageCounterBehaviorSubject = new BehaviorSubject();
const sysMessageCounterBehaviorSubject = new BehaviorSubject();

const messageComponentBehaviorSubject = new BehaviorSubject();
const footerComponentSubject = new BehaviorSubject();
const dialogCloseSubject = new BehaviorSubject();

export const userMessageService = {
  drawerComponentMessage: (item) => drawerMessageBehaviorSubject.next(item),
  getDrawerComponentMessage: () => drawerMessageBehaviorSubject.asObservable(),

  adMessageCounterMessage: (item) => adMessageCounterBehaviorSubject.next(item),
  getAdMessageCounterMessage: () =>
    adMessageCounterBehaviorSubject.asObservable(),
  busMessageCounterMessage: (item) =>
    busMessageCounterBehaviorSubject.next(item),
  getBusMessageCounterMessage: () =>
    busMessageCounterBehaviorSubject.asObservable(),
  sysMessageCounterMessage: (item) =>
    sysMessageCounterBehaviorSubject.next(item),
  getSysMessageCounterMessage: () =>
    sysMessageCounterBehaviorSubject.asObservable(),

  messageComponentUpdateMessage: (item) =>
    messageComponentBehaviorSubject.next(item),
  getMessageComponentMessage: () =>
    messageComponentBehaviorSubject.asObservable(),

  toggleDrawer: (item) => dialogCloseSubject.next(item),
  getToggleDrawer: () => dialogCloseSubject.asObservable(),
};
